
                export default function (Component) {
                    Component.__source = "library/layouts/VabLayoutCommon/index.vue"
                }
            